import axios from 'axios'
import convertUser from '@/api/converters/user'
import store from '@/store'

/**
 * Get user profile
 */
function getProfile () {
  return axios
    // Add query paramater as a “cache buster” for Internet Explorer:
    // Somehow IE doesn’t want to let go and re-uses old request responses.
    // The always-changing timestamp “fakes” a request to a different URL
    // everytime the own-profile API endpoint is fetched.
    .get(`own-profile/?time=${new Date().getTime()}`)
    .then(response => {
      const user = convertUser(response.data[0])

      store.commit('user/meta', user.meta)
      store.commit('user/profile', user.profile)

      return user
    })
}

/**
 * Get user image
 */
function getImage () {
  return axios
    .get('eigenes-lichtbild/', { responseType: 'blob' })
}

/**
 * Delete/deactivate user account and profile
 * @param {String} password User password
 */
function deleteAccount (password) {
  return axios
    .post('deactivate-account/', { password })
}

export default {
  getProfile,
  getImage,
  deleteAccount
}
